/**
 * @module utils/html-entities
 */

/**
 * @method decode
 * @description decodes a string
 * @param {String} str
 * @returns {String}
 */
export function decode(str) {
  return str && str.replace(/&#(\d+);/g, (match, dec) => {
    return String.fromCharCode(dec);
  });
}

/**
 * @method encode
 * @description encodes a string
 * @param {String} str
 * @returns {String}
 */
export function encode(str) {
  let buf = [];
  let i = str.length - 1;
  for (i; i >= 0; i--) {
    buf.unshift(["&#", str[i].charCodeAt(), ";"].join(""));
  }
  return buf.join("");
}
